import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/services/page.tsx");
